import { SettingsCard, ToggleField } from "./fields";
import type { SettingsTabProps } from "../settings";

export default function Bildirimler({ settings, update }: SettingsTabProps) {
  return (
    <SettingsCard
      title="Bildirim Tercihleri"
      description="Platform genelinde gönderilen otomatik bildirimlerin yönetimi."
    >
      <div className="space-y-3">
        <ToggleField
          label="E-posta bildirimleri"
          description="Ödev, sınav ve duyuru bildirimleri e-posta ile gönderilir."
          checked={settings.emailNotifications}
          onChange={(v) => update({ emailNotifications: v })}
        />
        <ToggleField
          label="SMS bildirimleri"
          description="Kritik duyurular SMS ile iletilir (SMS sağlayıcısı gerektirir)."
          checked={settings.smsNotifications}
          onChange={(v) => update({ smsNotifications: v })}
        />
        <ToggleField
          label="Haftalık özet"
          description="Velilere ve öğrencilere haftalık gelişim özeti gönderilir."
          checked={settings.weeklyDigest}
          onChange={(v) => update({ weeklyDigest: v })}
        />
        <ToggleField
          label="Yeni kayıt bildirimi"
          description="Yeni bir öğrenci kaydolduğunda yöneticiye bildirim gider."
          checked={settings.notifyOnNewRegistration}
          onChange={(v) => update({ notifyOnNewRegistration: v })}
        />
      </div>
    </SettingsCard>
  );
}